import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    width: 335,
    overflowY: 'hidden',
    overflowX: 'hidden',
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  listingCard: {
    margin: '5px',
  },
  listingsHolder: {
    height: 404,
    maxHeight: 404,
    width: 335,
    margin: 0,
    padding: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 269px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  imageGrid: {
    backgroundColor: theme.palette.base.white,
  },
  image: {
    width: '250px',
    padding: '5px',
    height: 'auto',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  description: {
    width: '100%',
    whiteSpace: 'pre-wrap',
    overFlowWrap: 'break-word',
    wordWrap: true,
  },
  applyNowButton: {
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
  },
}))

export default styles
